
import { Options, Vue } from 'vue-class-component';
import SwitchButton from '@/components/elements/switchButton/SwitchButton.vue';
import { Prop, Watch } from 'vue-property-decorator';
import { $api } from '@/services';
import EditMenu from '@/views/setupCenter/features/lucaAI/EditMenu.vue';

@Options({
	name: 'Report',
	components: { SwitchButton, EditMenu },
})
export default class SetupCenterLucaAi extends Vue {
	//----------------------- 🤍 Props 🤍 -----------------------//
	@Prop() org!: any;

	//----------------------- 🤍 Data 🤍 -----------------------//
	enable_ai_button = false;
	enabled_menu = false;
	onChange = false;
	onWatchOrg = true;
	sideOverShow = false;
	menu = [];
	limit_ai_chat_count = 10;
	editLimitAiChatCount = false;
	enable_limit_ai_chat = false;

	//----------------------- 🤍 Watch 🤍 -----------------------//
	@Watch('org', { deep: true, immediate: true })
	onOrgChange(org: any) {
		if (org && this.onWatchOrg) {
			this.enable_ai_button = org?.enable_ai_button;
			this.enabled_menu = org?.enabled_menu;
			this.enable_limit_ai_chat = org?.enable_limit_ai_chat;
			this.limit_ai_chat_count = org?.limit_ai_chat_count;
			setTimeout(() => {
				this.onChange = true;
			}, 1000);
			this.onWatchOrg = false;
		}
	}

	@Watch('enable_ai_button')
	onChangeAiButton(value: any) {
		if (this.onChange) {
			this.$emit('updateOrg', {
				enable_ai_button: value,
			});
		}
	}
	@Watch('enable_limit_ai_chat')
	onChangeLimitAiChat(value: any) {
		if (this.onChange) {
			this.$emit('updateOrg', {
				enable_limit_ai_chat: value,
				limit_ai_chat_count: this.limit_ai_chat_count || 10,
			});
		}
	}
	changeLimitAiChatCount() {
		this.editLimitAiChatCount = false;
		if (this.limit_ai_chat_count < 10) {
			const error =
				'Số tin nhắn giới hạn mỗi tháng phải lớn hơn hoặc bằng 10';
			this.$store.dispatch('setAlertMessage', {
				message: error,
				type: 'danger',
			});
			this.limit_ai_chat_count = 10;
		}
		this.$emit('updateOrg', {
			limit_ai_chat_count: this.limit_ai_chat_count,
		});
	}
	
	@Watch('enabled_menu')
	onChangeEnabledMenu(value: any) {
		if (this.onChange) {
			this.$emit('updateOrg', {
				enabled_menu: value,
			});
		}
	}

	//----------------------- 🤍 Methods 🤍 -----------------------//
	async getMenu() {
		try {
			const res = await $api.menu.list();
			this.menu = res?.data.data;
		} catch (err) {
			console.error(err);
		}
	}
	async updateMenu(menu: any) {
		try {
			this.sideOverShow = false;
			const res = await $api.menu.updateList({ default_meals: menu });
			if (res?.data) {
				this.$store.dispatch('setAlertMessage', {
					message: 'Cập nhật danh sách bữa ăn thành công',
					type: 'success',
				});
				this.getMenu();
			}
		} catch (err) {
			this.$store.dispatch('setAlertMessage', {
				message: 'Cập nhật thất bại',
				type: 'danger',
			});
		}
	}

	mounted() {
		if (this.enabled_menu) this.getMenu();
	}
}
